import { CSSProperties, useState } from 'react';
import { AutoTask } from '../../../../shared/types/autoTask.ts';
import { InfoIcon } from '../../../components/dialog-portal/infoIcon.tsx';
import { AutoTasksInfoDialog } from './autoTasksInfoDialog.tsx';
import { AutoTaskTableRow } from './autoTaskTableRow.tsx';
import { DisconnectedMachinesDialog } from './disconnectedMachinesDialog.tsx';
import { DisconnectedTaskRow } from './disconnectedTaskRow.tsx';
import { FixInProgressRow } from './fixInProgressRow.tsx';
import { FixMachinesDialog } from './fixMachinesDialog.tsx';
import { useAutoTaskRows } from './useAutoTaskRows.ts';

interface Props {
    style?: CSSProperties;
    tasks: AutoTask[];
}

export default function AutoTasksTable({ style, tasks }: Props) {
    const [isInfoOpen, setIsInfoOpen] = useState(false);
    const [isDisconnectedInfoOpen, setIsDisconnectedInfoOpen] = useState(false);
    const [isFixInfoOpen, setIsFixInfoOpen] = useState(false);

    const { rows, disconnectedSummary, fixSummary } = useAutoTaskRows(tasks);

    return (
        <>
            <table style={style ?? {}}>
                <thead>
                    <tr>
                        <th>Equipment name</th>
                        <th>Part number</th>
                        <th>Time remaining</th>
                        <th style={{ position: 'relative' }}>
                            <span>Notes</span>
                            <span
                                style={{
                                    position: 'absolute',
                                    right: 6,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                }}
                            >
                                <InfoIcon onClick={() => setIsInfoOpen(true)} title='Auto Tasks Info' />
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => {
                        if (row.kind === 'disconnectedSummary') {
                            return (
                                <DisconnectedTaskRow
                                    key='disconnected-summary'
                                    row={row}
                                    onClick={() => setIsDisconnectedInfoOpen(true)}
                                />
                            );
                        } else if (row.kind === 'fixSummary') {
                            return (
                                <FixInProgressRow
                                    key='fix-summary'
                                    row={row}
                                    onClick={() => setIsFixInfoOpen(true)}
                                />
                            );
                        } else {
                            const { task } = row;
                            return (
                                <AutoTaskTableRow
                                    key={task.equipment + '_' + task.type + '_' + (task.toolIndex ?? '0') + '_' + index}
                                    row={row}
                                />
                            );
                        }
                    })}
                </tbody>
            </table>

            {isInfoOpen && <AutoTasksInfoDialog onClose={() => setIsInfoOpen(false)} />}
            {isDisconnectedInfoOpen && disconnectedSummary && (
                <DisconnectedMachinesDialog tasks={disconnectedSummary.tasks} onClose={() => setIsDisconnectedInfoOpen(false)} />
            )}
            {isFixInfoOpen && fixSummary && (
                <FixMachinesDialog
                    tasks={fixSummary.tasks}
                    onClose={() => setIsFixInfoOpen(false)}
                />
            )}
        </>
    );
}
